import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

export default function ConfirmDialog(
  {open, onClose, message, onConfirm}: {open: boolean, onClose: any, message: string | JSX.Element, onConfirm: any}
) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title">{"Complete physician oversight?"}</DialogTitle>
      <DialogContent>
        {typeof message === 'string' ? (
          <DialogContentText id="confirm-dialog-description">
            {message}
          </DialogContentText>
        ) : message}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Back
        </Button>
        <Button onClick={onConfirm} variant="contained" color="secondary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}